import {Ventrata} from 'types'
import {InputElement} from './InputElement'

type Props = {
  question: Ventrata.Question
  bookingUuid: string
  unitItemId: string
}

export const Question = ({question, bookingUuid, unitItemId}: Props) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex">
        <span>{question.label}</span>
        {question.required && <span className="text-red-500">*</span>}
      </div>
      <InputElement bookingUuid={bookingUuid} unitItemId={unitItemId} question={question} />
    </div>
  )
}
